import React, {Fragment, Text}from "react";
import style from "./BadgeIcon.scss";

// This component has to be placed inside a container with "position:relative"
// Inside this container must be the icon logo and this BadgeIcon component.

const BadgeIcon = ({ count }) => {
  return (
    <div className={style.circle}>
      <span>{count}</span>
    </div>
  );
};

export default BadgeIcon;
